import React, { useRef } from "react";
import uploadMediaApi from "../../../api/upload-media.api";
import { MessageActionKind } from "../interfaces";
import { MESSAGE_CONFIG } from "../../../constents";
const getTypeConfig = (mime) => {
    switch (true) {
        case /^image(s)?.*$/.test(mime):
            return {
                type: MESSAGE_CONFIG.TYPES.MESSAGE_TYPE_IMAGE,
                subType: MESSAGE_CONFIG.SUB_TYPES.IMAGE_FROM_NORMAL
            };
        case /^video.*$/.test(mime):
            return {
                type: MESSAGE_CONFIG.TYPES.MESSAGE_TYPE_VIDEO,
                subType: MESSAGE_CONFIG.SUB_TYPES.VIDEO_FROM_NORMAL
            };
        case /^audio.*$/.test(mime):
            return {
                type: MESSAGE_CONFIG.TYPES.MESSAGE_TYPE_VOICE,
                subType: MESSAGE_CONFIG.SUB_TYPES.AUDIO_FROM_NORMAL
            };
        default:
            return {
                type: MESSAGE_CONFIG.TYPES.MESSAGE_TYPE_DOC,
                subType: MESSAGE_CONFIG.SUB_TYPES.DOC_FROM_NORMAL
            };
    }
};
const UploadAssetsForm = (props) => {
    const { sendMessageHandler, dispatch } = props;
    const uploadFileRef = useRef(null);
    const uploadFileRequest = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsArrayBuffer(file);
            reader.onload = (e) => {
                var _a;
                return uploadMediaApi({
                    onUploadProgress: (progress) => {
                        dispatch({
                            type: MessageActionKind.UPDATE_PROGRESS,
                            payload: {
                                progress
                            }
                        });
                    },
                    onDownloadProgress: (progress) => {
                        dispatch({
                            type: MessageActionKind.UPDATE_PROGRESS,
                            payload: {
                                progress
                            }
                        });
                    },
                    data: (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.result,
                    headers: {
                        "Content-Type": "multipart/form-data",
                    }
                })
                    .then(response => {
                    resolve(response);
                })
                    .catch((err) => {
                    console.log("error", err);
                    reject(err);
                });
            };
        });
    };
    const onUpload = (e) => {
        var _a;
        if (!((_a = e.target.files) === null || _a === void 0 ? void 0 : _a.length))
            return;
        const file = e.target.files[0];
        dispatch({
            type: MessageActionKind.SET_CONTENT,
            payload: {
                content: URL.createObjectURL(file),
                progress: 0,
                type: "media"
            }
        });
        uploadFileRequest(file).then(response => {
            const data = Object.assign({ text: "Uploaded Success", mime: response.data.mime, size: response.data.size, uri: response.data.uri }, getTypeConfig(response.data.mime));
            sendMessageHandler(Object.assign({}, data)).then(() => {
                dispatch({
                    type: MessageActionKind.CLEAR
                });
                e.target.value = '';
            });
        });
    };
    const onClickAssetsIcon = () => {
        var _a, _b;
        (_a = uploadFileRef.current) === null || _a === void 0 ? void 0 : _a.setAttribute("accept", "*");
        (_b = uploadFileRef.current) === null || _b === void 0 ? void 0 : _b.click();
    };
    const onClickCameraIcon = () => {
        var _a, _b;
        (_a = uploadFileRef.current) === null || _a === void 0 ? void 0 : _a.setAttribute("accept", "images/png");
        (_b = uploadFileRef.current) === null || _b === void 0 ? void 0 : _b.click();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("input", { type: "file", onInput: onUpload, style: { display: "none" }, ref: uploadFileRef }),
        React.createElement("button", { className: 'btn btn-sm btn-icon btn-active-light-primary me-1', type: 'button', onClick: onClickAssetsIcon, "data-bs-toggle": 'tooltip' },
            React.createElement("i", { className: "fa-solid fs-1 fa-camera" })),
        React.createElement("button", { className: 'btn btn-sm btn-icon btn-active-light-primary me-1', type: 'button', onClick: onClickCameraIcon, "data-bs-toggle": 'tooltip' },
            React.createElement("i", { className: "fa-solid fs-1 fa-upload" }))));
};
export default UploadAssetsForm;
